import { createSelector } from 'reselect'
import { parseImageUrl, sortPosPrices } from './helper'
import { getMenuOptions } from '../../../component/Product/form/menu/ProductMenuFormV2/main/constructorImg/helper'
import { productTypeOptions } from '../../reducer/product/constants'
import { selectIsAustrianCompany } from '../system'
import { buildCopySourceTree } from '../../../component/Product/form/product/ProductFormV2/labeling/copy/model'

export const selectCategories = state => state.category.categories
export const selectProductLabeling = store => store.product.productLabeling
export const selectProductLabelingIsLoading = store => store.product.productLabelingIsLoading
export const selectProductLabelingLoadFailed = store => store.product.productLabelingLoadFailed
export const selectLabelingCopySourcesIsLoading = store => store.product.labelingCopySourcesIsLoading
export const selectLabelingCopySourceSelectedId = store => store.product.labelingCopySourceSelectedId
export const selectLabelingCopySourceLabeling = store => store.product.labelingCopySourceLabeling
export const selectLabelingCopySourceLabelingIsLoading = store => store.product.labelingCopySourceLabelingIsLoading
const selectLabelingCopySources = store => store.product.labelingCopySources
const selectProduct = store => store.product?.product

export const selectLabelingCopySourceTree = createSelector(
	selectLabelingCopySources,
	selectCategories,
	(sources, categories) => buildCopySourceTree(sources, categories ?? []),
)

export const selectProductLegacyLabeling = createSelector(
	selectProduct,
	(product) => ({
		allergens: product?.allergens ?? null,
		foodAdditives: product?.foodAdditives ?? null,
	}),
)
export const selectPosPrices = createSelector(
	selectCategories,
	selectProduct,

	(categories, product) => {
		if (!product) return []
		if (!product.category) return product.posPrices
		const category = categories?.find(category => category.id === product?.category?.id)

		const posPrices = product?.posPrices.map((item) => {
			const formattedPrice = []
			category?.priceDescriptions.forEach((categoryPrice) => {
				const price = item.prices.find(price => categoryPrice.id === price.priceTitle.id)
				formattedPrice.push(price)
			})
			return {
				...item,
				prices: formattedPrice,
			}
		})

		return sortPosPrices(posPrices)
	},
)

const selectImgSourceType = store => store.product?.imgSourceType

export const selectSelectedMenu = createSelector(
	selectImgSourceType,
	selectProduct,
	(imgSourceType, product) => {
		if (!product) return null

		if (imgSourceType === 'CUSTOM') {
			const productMenu = product.menuPositions?.[0]?.products?.[0] || null
			return {
				productMenu,
				productMenuTheme: 'light',
			}
		}

		const imgUrl = product.imgDefaultUrl
		if (!imgUrl) return null

		const parsed = parseImageUrl(imgUrl)
		if (!parsed) return null

		const { theme, value } = parsed
		const productMenu = getMenuOptions(theme).find(item => item.value === value) || null

		return {
			productMenu,
			productMenuTheme: theme,
		}
	},
)

export const selectProductTypeOptions = createSelector(
	selectIsAustrianCompany,
	isAustrianCompany => productTypeOptions.filter(option => option.value !== 'BASIC_FOOD' || isAustrianCompany),
)
